import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            submit: 'onSubmit'
        };
    }

    init() {
        this.$form = this.el;
        this.actionUrl = this.$form.getAttribute('action');
    }

    onSubmit(event) {
        event.preventDefault();

        if (!this.actionUrl || !this.$form) return;

        const formData = new FormData(this.$form);

        const email = formData.get('EMAIL');
        const currentLocale = window?.Shopify?.locale || 'en';

        let constructedUrl = `${this.actionUrl}`;
        constructedUrl += `&MERGE0=${email}`;
        constructedUrl += `&MERGE5=${currentLocale === 'en' ? 'English' : 'Français'}`;

        window.open(constructedUrl, '_blank')?.focus();

        this.$form.reset();
    }
}
